import React from "react" // eslint-disable-line no-unused-vars
/** @jsx jsx */
import { jsx, Grid, Box } from "theme-ui"

import ProgrammeSponsorItem from "./ProgrammeSponsorItem"

function ProgrammeSponsors({ sponsors }) {
  return (
    <Grid columns={[1, 2]} gap={0}>
      <Box
        sx={{
          variant: "layout.paddedItemTLR",
          mb: [7, 8],
          pr: 3,
          "@media (min-width: 40em)": { pr: "80px" },
          "@media (min-width: 120em)": { pr: "200px" },
        }}
      >
        {sponsors.map((sponsor, index) => {
          return (
            <ProgrammeSponsorItem
              key={`sponosr-item-${index}`}
              sponsor={sponsor}
            />
          )
        })}
      </Box>
    </Grid>
  )
}

export default ProgrammeSponsors
